module.exports = __webpack_public_path__ + "img/1455707876.f8b2115d.jpg";